import { IResults, IErrorType, } from '../state-helpers/search-results';
import * as actions from '../actions/index';
import * as _ from 'lodash';

const defaultResultsModel = Object.freeze({
    searchItemList: [],
    categories: [],
    loading: false,
    currentPage: 1,
    errorMessage: '',
    totalNumber: 0,
    totalPages: 0,
    showResults: true,
    errorType: IErrorType.NONE,
    noResultsWYSIWYG: "",
    generativeResult: "",
    generativeResultHeader: "",
    disableGenerativeResult: false
});


export function resultsModel(state: IResults, action: actions.IResultsLoadedAction) {
    if (typeof state === 'undefined') {
        state = defaultResultsModel
    }

    switch (action.type) {
        case actions.ActionType.SET_PAGE:
            return _.assign({}, state, { loading: false });
        case actions.ActionType.RESULTS_LOADING:
            return _.assign({}, state, { loading: action.isLoading });
        case actions.ActionType.SHOW_RESULTS:
            return _.assign({}, state, { showResults: action.showResults });
        case actions.ActionType.SET_PAGE:
            return _.assign({}, state, { loading: true });
        case actions.ActionType.RESULTS_LOADED:
            return _.assign({}, state, {
                loading: false,
                searchItemList: action.results,
                categories: action.categories,
                totalNumber: action.totalNumber,
                totalPages: action.totalPages,
                errorMessage: '',
                errorType: IErrorType.NONE,
                noResultsWYSIWYG: action.noResultsWYSIWYG,
                generativeResult: action.generativeResult,
                generativeResultHeader: action.generativeResultHeader,
                disableGenerativeResult: action.disableGenerativeResult
            });
        case actions.ActionType.RESULTS_LOAD_FAILURE:
            return _.assign({}, state, {
                loading: false,
                errorMessage: action.errorMessage,
                errorType: action.errorType,
                searchItemList: [],
                categories: [],
                totalNumber: 0,
                totalPages: 0,
                noResultsWYWIWYG: action.noResultsWYSIWYG,
                generativeResult: '',
                generativeResultHeader: '',
                disableGenerativeResult: false
            });
        case actions.ActionType.CLEAR_ERROR_TEXT:
            return _.assign({}, state, { errorMessage: '', errorType: IErrorType.NONE });
        case actions.ActionType.BROWSER_NAVIGATION:
            return _.assign({}, state, {
                currentPage: action.page,
                loading: true
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/reducers/results-model.ts